import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getPlatformlogs = async () => {
    const url = `${NGROK}/api/server-audit-logs`
    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};
